import React from 'react';
import { useAtom } from 'jotai';
import { Segmented } from 'antd';
import { scanWidthState, scanningState, scanTypeState } from '../stateManagement/processState';
import { mapState } from '../stateManagement/commonState';

const SmallSquare = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none">
    <rect x="12" y="12" width="24" height="24" rx="4" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
    <circle cx="18" cy="18" r="2" fill="currentColor" />
    <circle cx="24" cy="18" r="2" fill="currentColor" />
    <circle cx="30" cy="18" r="2" fill="currentColor" />
    <circle cx="18" cy="24" r="2" fill="currentColor" />
    <circle cx="24" cy="24" r="2" fill="currentColor" />
    <circle cx="30" cy="24" r="2" fill="currentColor" />
    <circle cx="18" cy="30" r="2" fill="currentColor" />
    <circle cx="24" cy="30" r="2" fill="currentColor" />
    <circle cx="30" cy="30" r="2" fill="currentColor" />
  </svg>
);

const LargeSquare = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none">
    <rect x="4" y="4" width="40" height="40" rx="5" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
    <circle cx="14" cy="14" r="2" fill="currentColor" />
    <circle cx="24" cy="14" r="2" fill="currentColor" />
    <circle cx="34" cy="14" r="2" fill="currentColor" />
    <circle cx="14" cy="24" r="2" fill="currentColor" />
    <circle cx="24" cy="24" r="2" fill="currentColor" />
    <circle cx="34" cy="24" r="2" fill="currentColor" />
    <circle cx="14" cy="34" r="2" fill="currentColor" />
    <circle cx="24" cy="34" r="2" fill="currentColor" />
    <circle cx="34" cy="34" r="2" fill="currentColor" />
  </svg>
);

const ScanWidthToggle = () => {
  const [scanWidth, setScanWidth] = useAtom(scanWidthState);
  const [scanning] = useAtom(scanningState);
  const [map] = useAtom(mapState);
  const [scanType] = useAtom(scanTypeState);

  const isDisabled = scanning || map.length > 0 || scanType === 'reference';

  const toggle = () => {
    if (!isDisabled) setScanWidth(scanWidth === 5 ? 2 : 5);
  };

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
      <p style={{ display: 'block', textAlign: 'center', margin: '8px 0 4px 0' }}>Scan Area</p>
      <div onClick={toggle} style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', position: 'relative' }}>
        <Segmented
          value={scanWidth}
          disabled={isDisabled}
          style={{ pointerEvents: 'none' }}
          options={[
            {
              value: 2,
              label: (
                <div style={{ width: 36, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <SmallSquare />
                </div>
              ),
            },
            {
              value: 5,
              label: (
                <div style={{ width: 36, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <LargeSquare />
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ScanWidthToggle;
